// import React from "react";
import React, { useEffect, useState } from "react";
import "./update.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

const API_URL = process.env.REACT_APP_API_URL || "https://api.transtrackglobal.in";


export const UpdateUser = () => {
  const users = {
    client: "",
    resourceName: "",
    recruiterName: "",
    gender: "",
    dob: "",
    email: "",
    mobile: "",
    dojTapl: "",
    dojE: "",
    domain: "",
    location: "",
    lineManager: "",
    lmEmail: "",
    lmMobile: "",
    jobStage: "",
    jobRole: "",
    rateCard: "",
    ctc: "",
    monthlyctc: "",
    lastWorkingDay: "",
    aadhar: "",
    pan: "",
    refName1: "",
    refName2: "",
    refMobile1: "",
    refMobile2: "",
    woNo: "",
    woRenewalDate: "",
  };

  const [user, setUsers] = useState(users);
  const [domainOptions, setDomainOptions] = useState([]);
  const [showDomainModal, setShowDomainModal] = useState(false);
  const [newDomain, setNewDomain] = useState("");
  const userType = localStorage.getItem("userType");
  const navigate = useNavigate();
  const { id } = useParams();

  const fetchDomains = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/domains`);
      setDomainOptions(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const inputHandler = (e) => {
    const { name, value } = e.target;
    
    if (name === "ctc") {
      const monthly = value ? (Number(value) / 12).toFixed(2) : "";
      setUsers((prev) => ({
        ...prev,
        [name]: value,
        ctc: value,
        monthlyctc: monthly,
      }));
      return;
    }

    setUsers((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    fetchDomains();
    axios
      .get(`${API_URL}/api/getUserById/${id}`)
      .then((response) => {
        // setUsers(response.data.userExist);
        const data = response.data.userExist;
        setUsers({
          ...data,
          dob: formatDate(data.dob),
          dojTapl: formatDate(data.dojTapl),
          dojE: formatDate(data.dojE),
          lastWorkingDay: formatDate(data.lastWorkingDay),
          woRenewalDate: formatDate(data.woRenewalDate),
        });
      })
      .catch((error) => console.log(error));
  }, [id]);

  const formatDate = (dateString) =>
    dateString ? dateString.split("T")[0] : "";

  const handleAddDomain = async () => {
    if (!newDomain.trim()) return;
    try {
      const res = await axios.post(`${API_URL}/api/domains/add`, { name: newDomain });
      toast.success(res.data.message);
      setNewDomain("");
      setShowDomainModal(false);
      fetchDomains(); // Refresh list
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to add domain");
    }
  };

  const isValidAadhar = (aadhar) => /^\d{12}$/.test(aadhar);
  const isValidPan = (pan) =>
    /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan.toUpperCase());
  const isValidPhone = (num) => /^\d{10}$/.test(num);

  const getMissingFields = () => {
    const missing = [];
    if (!user.resourceName?.toString().trim()) missing.push("Resource Name");
    if (!user.client?.toString().trim()) missing.push("Client");
    if (!user.recruiterName?.toString().trim()) missing.push("Recruiter Name");
    if (!user.gender) missing.push("Gender");
    if (!user.email?.toString().trim()) missing.push("Email");
    if (!user.mobile?.toString().trim() || user.mobile?.toString().length !== 10) missing.push("Mobile (10 digits)");
    if (!user.domain) missing.push("Domain");
    if (!user.jobRole?.toString().trim()) missing.push("Job Role");
    if (user.rateCard === "" || user.rateCard === null || user.rateCard === undefined) missing.push("Rate Card");
    if (user.ctc === "" || user.ctc === null || user.ctc === undefined) missing.push("CTC");
    if (!user.jobStage) missing.push("Job Stage");
    return missing;
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const missingFields = getMissingFields();
    if (missingFields.length > 0) {
      toast.error(`Please fill mandatory fields: ${missingFields.join(", ")}`);
      return;
    }

    if (user.aadhar && !isValidAadhar(user.aadhar)) {
      toast.error("Invalid Aadhar number. It must be 12 digits.");
      return;
    }

    if (user.pan && !isValidPan(user.pan)) {
      toast.error("Invalid PAN number.");
      return;
    }

    try {
      const res = await axios.put(
        `${API_URL}/api/update/${id}`,
        user
      );
      toast.success(res.data.message, { position: "top-right" });
      navigate("/user");
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update user");
      console.log(error);
    }
  };

  return (
    <div className="addUser page-3d">
      {/* HEADER */}
      <div className="form-header-3d reverse">
        <h3 className="form-title-3d">UPDATE USER DATA</h3>

        <Link to="/user" className="outline-btn text-decoration-none">
          <i className="fa-solid fa-arrow-left"></i> Back
        </Link>
      </div>

      {/* FORM */}
      <form className="addUserForm form-3d" onSubmit={submitForm}>
        {[
          ["Client", "client"],
          ["Resource Name", "resourceName"],
          ["Recruiter Name", "recruiterName"],
          ["Gender", "gender", "select"],
          ["DOB", "dob", "date"],
          ["Email", "email"],
          ["Mobile", "mobile"],
          ["DOJ TAPL", "dojTapl", "date"],
          ["DOJ Client", "dojE", "date"],
          ["Domain", "domain", "datalist"],
          ["Location", "location"],
          ["Line Manager", "lineManager"],
          ["LM Email", "lmEmail"],
          ["LM Mobile", "lmMobile"],
          ["Job Stage", "jobStage", "select"],
          ["Job Role", "jobRole"],
          ["Rate Card", "rateCard", "number"],
          ["CTC", "ctc", "number"],
          ["Monthly CTC", "monthlyctc", "number"],
          ["LWD", "lastWorkingDay", "date"],
          ["Aadhar", "aadhar"],
          ["PAN", "pan"],
          ["Ref Name 1", "refName1"],
          ["Ref Mobile 1", "refMobile1"],
          ["Ref Name 2", "refName2"],
          ["Ref Mobile 2", "refMobile2"],
          ["WO No", "woNo"],
        ].map(([label, name, type]) => (
          <div className="inputGroup input-3d" key={name}>
            <label>{label}</label>
            {type === "select" ? (
              <select
                name={name}
                value={user[name] || ""}
                onChange={inputHandler}
              >
                <option value="">Select</option>

                {name === "gender" && (
                  <>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </>
                )}

                {name === "jobStage" && (
                  <>
                    <option value="Pipeline">Pipeline</option>
                    <option value="Shortlisted">Shortlisted</option>
                    <option value="Offered">Offered</option>
                    <option value="Joined">Joined</option>
                    <option value="Serving NP">Serving NP</option>
                    <option value="Released">Released</option>
                    <option value="Absconded">Absconded</option>
                    <option value="Dropout">Dropout</option>
                  </>
                )}
              </select>
            ) : type === "datalist" && name === "domain" ? (
              <>
                <div className="d-flex gap-2 w-100">
                  <select
                    name={name}
                    value={user[name] || ""}
                    onChange={inputHandler}
                    className="flex-grow-1 form-select"
                    style={{ padding: '10px' }}
                  >
                    <option value="">Select Domain</option>
                    {domainOptions.map((d) => (
                      <option key={d._id} value={d.name}>{d.name}</option>
                    ))}
                  </select>
                  {(userType === "admin" || userType === "superadmin") && (
                    <button type="button" onClick={() => setShowDomainModal(true)} className="btn outline-btn px-3" title="Add Domain">
                      <i className="bi bi-plus-lg"></i>
                    </button>
                  )}
                </div>
              </>
            ) : (
              <input
                type={type || "text"}
                name={name}
                value={user[name] || ""}
                onChange={inputHandler}
              />
            )}
          </div>
        ))}

        {/* LAST ROW */}
        <div className="inputGroup input-3d">
          <label>WO Renewal Date</label>
          <input
            type="date"
            name="woRenewalDate"
            value={user.woRenewalDate || ""}
            onChange={inputHandler}
          />
        </div>

        {/* SUBMIT */}
        <div className="submit-inline">
          <button type="submit" className="submitbtn submit-btn-3d">
            <i className="fa-solid fa-rotate"></i> Update
          </button>
        </div>
      </form>

      {/* DOMAIN MODAL */}
      {showDomainModal && (
        <div className="modal-overlay-modern">
          <div className="modal-card-modern" style={{ maxWidth: '400px' }}>
            <div className="modal-header-modern">
              <h5 className="mb-0"><i className="bi bi-plus-circle me-2"></i> Add New Domain</h5>
              <button type="button" className="btn-close-modern" onClick={() => setShowDomainModal(false)}><i className="bi bi-x-lg"></i></button>
            </div>
            <div className="p-4">
              <div className="input-group-modern mb-0">
                <label>Domain Name</label>
                <input type="text" value={newDomain} onChange={(e) => setNewDomain(e.target.value)} placeholder="e.g. Healthcare" />
              </div>
            </div>
            <div className="modal-footer-modern">
              <button type="button" className="btn outline-btn" onClick={() => setShowDomainModal(false)}>Cancel</button>
              <button type="button" className="btn gradient-btn" onClick={handleAddDomain}>Add Domain</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default UpdateUser;
